import React from 'react';
import { Stack } from '@mui/material';
import { Person } from '../../types';
import { PersonCard } from '../person/PersonCard';

/**
 * PeopleList Component
 *
 * Displays people in a list layout (single column)
 *
 * Features:
 * - Uses existing PersonCard component with variant="summary"
 * - Single column layout
 * - More condensed than grid
 * - Shows relationship count, photo count
 *
 * @component
 * @param {PeopleListProps} props - Component props
 * @returns {JSX.Element} List view of people
 */
interface PeopleListProps {
  persons: Person[];
  onPersonClick: (personId: string) => void;
}

export const PeopleList: React.FC<PeopleListProps> = ({
  persons,
  onPersonClick,
}) => {
  // ===== Event Handlers =====
  const handlePersonView = (person: Person | import('../../types').PersonSummary) => {
    onPersonClick(person.id);
  };

  // ===== Render =====
  return (
    <Stack spacing={2}>
      {persons.map((person) => (
        <PersonCard
          key={person.id}
          person={person}
          variant="summary"
          showActions={false}
          onView={handlePersonView}
        />
      ))}
    </Stack>
  );
};

export default PeopleList;
